import { OrderedMap } from 'immutable';

/**
 * @param {Draft.ContentState} content
 * @returns {Draft.ContentState}
 */
export function filterEmptyBlocks(content) {
	const blockMap = content.getBlockMap();
	let newBlockMap = OrderedMap();

	/** @type {Draft.ContentBlock} */
	let lastBlock = null;
	blockMap.forEach((block, key) => {
		if (!lastBlock || !isEmptyBlock(block)) {
			newBlockMap = newBlockMap.set(key, block);
		}
		lastBlock = block;
	});

	return content.set('blockMap', newBlockMap);
}

/**
 * @param {Draft.ContentBlock} block
 */
function isEmptyBlock(block) {
	const text = block.getText();
	return !text || text.trim().length === 0;
}



// WEBPACK FOOTER //
// ./lib/helpers/filterEmptyBlocks.js